/* ================================================== */
/* MENU → Inits
/* ================================================== */

var menuClass       = '#layout--menu',
	menuMobileClass = '#layout--header',

	$menu           = $(menuClass),
	$menuMobile     = $(menuMobileClass),
	$menuTrigger    = $('.link--menu'),

	openClass       = 'open',
	activeClass     = '.link--active',

	$openMenu       = $menu.find('.link--menu'),
	$closeMenu      = $menu.find(activeClass);


/* ================================================== */
/* MENU → Inits → accessibility
/* ================================================== */

$(document).ready(function(){

	// Unset focus on menu links
	$('a', $menu).attr('tabindex', '-1');

});